import { cloneDeep } from "lodash";

const defaultClaimsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ceReceivable",
  filters: [],
};

const defaultStates = {
  claimsManager: {
    hasFilterd: false,
    search: cloneDeep(defaultClaimsFilter),
    pharmacies: [],
    patients: [],
    claimStatus: {},
    coveredEntity: {},
    pharmacy: {},
    statusname: {},
    searchPatientTerm: "",
    patient: "",
    provider: "",
    searchTerms: {
      coveredEntityID: "",
      pharmacyID: "",
      patientID: "",
      rxNumber: "",
      providerID: "",
      providerFirstName: "",
      startDate: "",
      endDate: "",
      claimStatusID: "",
      pharmacyIds: {},
      claimStatusIds: {},
    },
  },
  dashboard: {
    hasFilterd: false,
    search: [],
    coveredEntities: [],
    accmulations: [],
    searchTerms: {
      coveredEntityID: {},
      chainPharmacyID: null,
      pharmacyIds: null,
      startDate: "",
      endDate: "",
      dateRangeID: 4
    },
  },
};

const initialStates = {
  loading: false,
  claimsManager: cloneDeep(defaultStates.claimsManager),
  dashboard: cloneDeep(defaultStates.dashboard),
};

export { initialStates, defaultStates };
